export const T = {
  en_GB: {
    private: "Private",
    privateHint: "Only the client owner can see this client.",
    privateWinsHint: "Only the client owner can see this client, even if it has teams.",
    teamsWithAccess: "Teams with access",
    teams: "Teams",
    teamsPlaceholderAccess: "No teams (owner only)",
    teamsPlaceholder: "No teams",
    teamsAccessHint:
      "Only the owner and members of these teams can see this client. No teams: only the owner.",
    teamsHint: "Teams group clients for filtering. They do not limit who can see the client.",
    readOnly: "Only the client owner or an administrator can change this.",
  },
  nb_NO: {
    private: "Privat",
    privateHint: "Bare kundens eier kan se denne kunden.",
    privateWinsHint: "Bare kundens eier kan se denne kunden, selv om den har team.",
    teamsWithAccess: "Team med tilgang",
    teams: "Team",
    teamsPlaceholderAccess: "Ingen team (bare eieren)",
    teamsPlaceholder: "Ingen team",
    teamsAccessHint:
      "Bare eieren og medlemmer av disse teamene kan se kunden. Ingen team: bare eieren.",
    teamsHint: "Team grupperer kunder for filtrering. De begrenser ikke hvem som kan se kunden.",
    readOnly: "Bare kundens eier eller en administrator kan endre dette.",
  },
} as const;
